import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=080af826&scoped=true&"
import script from "./detailList.vue?vue&type=script&lang=js&"
export * from "./detailList.vue?vue&type=script&lang=js&"
import style0 from "./detailList.vue?vue&type=style&index=0&id=080af826&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080af826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080af826')) {
      api.createRecord('080af826', component.options)
    } else {
      api.reload('080af826', component.options)
    }
    module.hot.accept("./detailList.vue?vue&type=template&id=080af826&scoped=true&", function () {
      api.rerender('080af826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/order-management-rules/form/components/detailList.vue"
export default component.exports